import React from 'react'
import Header from '../components/Header/Header'
import Navbar from '../components/Navbar/Navbar'

const Poster_Presentation_Awards = () => {
    return (
        <div>
            <Header/>
            <Navbar/>
            <div className="px-4">
                  <div className="max-w-7xl mx-auto bg-white p-6 ">
                    {/* Header Section */}
                    <header className="flex justify-between items-center mb-2 pb-6">
                      <h1 className="text-3xl md:text-4xl text-blue-800 ">I.I.S. Awards</h1>
                    
                    </header>
            
                    {/* Content Section */}
                    <section>
                      <h2 className="text-2xl md:text-3xl text-gray-600 mb-4 "> Poster Presentation Awards</h2>
                      <p className="text-md md:text-lg text-gray-600 mb-4">
                      15 best posters will be awarded in the closing ceremony.  </p>
                     
                    </section>
                  </div>
                </div>
        </div>
    )
}

export default Poster_Presentation_Awards
